import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_ctx.syncState === 'BUG')
    ? (_openBlock(), _createBlock(_component_v_row, {
        key: 0,
        "no-gutters": "",
        class: "bg-light-red my-2 rounded"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "6",
            class: "rounded-right white px-2",
            style: {"position":"relative"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_img, {
                height: "50px",
                width: "50",
                contain: "",
                src: "/img/ameli.png"
              }),
              _cache[1] || (_cache[1] = _createElementVNode("h5", null, "Ameli", -1)),
              _createVNode(_component_v_icon, {
                class: "mr-2 text-muted",
                size: "x-small"
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("$fa-sync-alt")
                ])),
                _: 1
              }),
              _cache[2] || (_cache[2] = _createElementVNode("span", {
                class: "text-muted",
                size: "x-small"
              }, "18 mars 2024 - 2:49", -1)),
              _createVNode(_component_v_btn_icon, {
                icon: "$fa-gear",
                size: "small",
                style: {"position":"absolute","top":"5px","right":"5px"}
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "6",
            class: "px-2"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_v_icon, {
                  class: "mr-2 text-error",
                  size: "x-small"
                }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode("$fa-question-circle")
                  ])),
                  _: 1
                }),
                _cache[4] || (_cache[4] = _createElementVNode("span", {
                  size: "x-small",
                  class: "text-error"
                }, "Bug", -1))
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("div", {
                size: "x-small",
                class: "text-error"
              }, " La synchronisation de cette connexion rencontre des problèmes. ", -1))
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : (_ctx.syncState === 'OK')
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 1,
          "no-gutters": "",
          class: "bg-light-green my-2 rounded"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "6",
              class: "rounded-right white px-2",
              style: {"position":"relative"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_img, {
                  height: "50px",
                  width: "50",
                  contain: "",
                  src: "/img/magento.png"
                }),
                _cache[7] || (_cache[7] = _createElementVNode("h5", null, "Magento", -1)),
                _createVNode(_component_v_icon, {
                  class: "mr-2 text-muted",
                  size: "x-small"
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode("$fa-sync-alt")
                  ])),
                  _: 1
                }),
                _cache[8] || (_cache[8] = _createElementVNode("span", {
                  class: "text-muted",
                  size: "x-small"
                }, "18 mars 2024 - 2:49", -1)),
                _createVNode(_component_v_btn_icon, {
                  icon: "$fa-gear",
                  size: "small",
                  style: {"position":"absolute","top":"5px","right":"5px"}
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "6",
              class: "px-2"
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createElementVNode("div", {
                  size: "x-small",
                  class: "d-flex justify-content-center pt-3"
                }, " La synchronisation de cette connexion rencontre des problèmes. ", -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
}